import { render } from "./SlideDataForm.vue?vue&type=template&id=af1f24fa&scoped=true"
import script from "./SlideDataForm.vue?vue&type=script&lang=js"
export * from "./SlideDataForm.vue?vue&type=script&lang=js"

import "./SlideDataForm.vue?vue&type=style&index=0&id=af1f24fa&lang=scss&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af1f24fa"]])

export default __exports__